import {
  apiGet,
  type ApiRequestOptions,
} from "@softmax/observatory-client/client";
import { ApiError } from "@softmax/observatory-client/transport";
import type { Schemas } from "@softmax/observatory-client/types";

export function readStorePagePermissions({
  coworld,
  signal,
}: {
  coworld: string;
  signal?: AbortSignal | undefined;
}): Promise<Schemas["StorePagePermissionsPublic"]> {
  const options: ApiRequestOptions = {
    elevatedPrivileges: false,
    timeoutMs: 5_000,
  };

  if (signal !== undefined) options.signal = signal;

  return apiGet<Schemas["StorePagePermissionsPublic"]>(
    `/v2/coworlds/${encodeURIComponent(coworld)}/store-page/permissions`,
    options,
  ).then(undefined, (error: unknown) => {
    if (error instanceof ApiError && [401, 403, 404].includes(error.status))
      return { can_edit: false };

    throw error;
  });
}
